import { labels } from 'presentation/constant/labels'
import { validateLoginP2p } from 'presentation/utils/format'

export const validateLoginP2pString = (loginP2p: string) => {
  if (loginP2p === '') {
    return labels.form.requiredFieldText
  }
  if (!validateLoginP2p(loginP2p)) {
    return labels.form.wrongDatesText
  }
  return ''
}
